var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemovePhotoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Photo, Edit/Photo"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 5H5C3.895 5 3 5.895 3 7V19C3 20.105 3.895 21 5 21H18C19.105 21 20 20.105 20 19V5",
    fill: "#01181B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.9674 16.4671L8.4714 14.0811C8.8204 13.5281 9.5974 13.4531 10.0454 13.9291L11.1204 15.0711L12.2474 12.6761C12.5944 11.9381 13.6324 11.9041 14.0274 12.6181L16.1814 16.5161C16.5494 17.1831 16.0664 18.0001 15.3054 18.0001H7.8134C7.0254 18.0001 6.5474 17.1331 6.9674 16.4671Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-3-outside-1_30_29806",
    maskUnits: "userSpaceOnUse",
    x: 9.51472,
    y: -2.48517,
    width: 16.9706,
    height: 16.9706,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 9.51472,
    y: -2.48517,
    width: 16.9706,
    height: 16.9706
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8284 4.71447C21.2545 4.28844 21.2545 3.59772 20.8284 3.17169C20.4024 2.74566 19.7117 2.74566 19.2856 3.17169L18 4.45734L16.7144 3.17169C16.2883 2.74566 15.5976 2.74566 15.1716 3.17169C14.7455 3.59772 14.7455 4.28844 15.1716 4.71447L16.4572 6.00012L15.1716 7.28576C14.7455 7.71179 14.7455 8.40252 15.1716 8.82854C15.5976 9.25457 16.2883 9.25457 16.7144 8.82854L18 7.54289L19.2856 8.82854C19.7117 9.25457 20.4024 9.25457 20.8284 8.82854C21.2545 8.40252 21.2545 7.71179 20.8284 7.28576L19.5428 6.00012L20.8284 4.71447Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8284 4.71447C21.2545 4.28844 21.2545 3.59772 20.8284 3.17169C20.4024 2.74566 19.7117 2.74566 19.2856 3.17169L18 4.45734L16.7144 3.17169C16.2883 2.74566 15.5976 2.74566 15.1716 3.17169C14.7455 3.59772 14.7455 4.28844 15.1716 4.71447L16.4572 6.00012L15.1716 7.28576C14.7455 7.71179 14.7455 8.40252 15.1716 8.82854C15.5976 9.25457 16.2883 9.25457 16.7144 8.82854L18 7.54289L19.2856 8.82854C19.7117 9.25457 20.4024 9.25457 20.8284 8.82854C21.2545 8.40252 21.2545 7.71179 20.8284 7.28576L19.5428 6.00012L20.8284 4.71447Z",
    fill: "#01181B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 4.45734L16.9393 5.518C17.5251 6.10378 18.4749 6.10378 19.0607 5.518L18 4.45734ZM16.4572 6.00012L17.5179 7.06078C18.1037 6.47499 18.1037 5.52524 17.5179 4.93946L16.4572 6.00012ZM18 7.54289L19.0607 6.48223C18.4749 5.89645 17.5251 5.89645 16.9393 6.48223L18 7.54289ZM19.5428 6.00012L18.4821 4.93946C17.8963 5.52524 17.8963 6.47499 18.4821 7.06078L19.5428 6.00012ZM19.7678 4.23235C19.608 4.07259 19.608 3.81357 19.7678 3.65381L21.8891 5.77513C22.9009 4.76331 22.9009 3.12284 21.8891 2.11103L19.7678 4.23235ZM20.3463 4.23235C20.1865 4.39211 19.9275 4.39211 19.7678 4.23235L21.8891 2.11103C20.8773 1.09922 19.2368 1.09922 18.225 2.11103L20.3463 4.23235ZM19.0607 5.518L20.3463 4.23235L18.225 2.11103L16.9393 3.39668L19.0607 5.518ZM15.6537 4.23235L16.9393 5.518L19.0607 3.39668L17.775 2.11103L15.6537 4.23235ZM16.2322 4.23235C16.0725 4.39211 15.8135 4.39211 15.6537 4.23235L17.775 2.11103C16.7632 1.09922 15.1227 1.09922 14.1109 2.11103L16.2322 4.23235ZM16.2322 3.65381C16.392 3.81357 16.392 4.07259 16.2322 4.23235L14.1109 2.11103C13.0991 3.12284 13.0991 4.76331 14.1109 5.77513L16.2322 3.65381ZM17.5179 4.93946L16.2322 3.65381L14.1109 5.77513L15.3966 7.06078L17.5179 4.93946ZM16.2322 8.34642L17.5179 7.06078L15.3966 4.93946L14.1109 6.2251L16.2322 8.34642ZM16.2322 7.76788C16.392 7.92764 16.392 8.18667 16.2322 8.34642L14.1109 6.2251C13.0991 7.23692 13.0991 8.87739 14.1109 9.8892L16.2322 7.76788ZM15.6537 7.76788C15.8135 7.60812 16.0725 7.60812 16.2322 7.76788L14.1109 9.8892C15.1227 10.901 16.7632 10.901 17.775 9.8892L15.6537 7.76788ZM16.9393 6.48223L15.6537 7.76788L17.775 9.8892L19.0607 8.60355L16.9393 6.48223ZM20.3463 7.76788L19.0607 6.48223L16.9393 8.60355L18.225 9.8892L20.3463 7.76788ZM19.7678 7.76788C19.9275 7.60812 20.1865 7.60812 20.3463 7.76788L18.225 9.8892C19.2368 10.901 20.8773 10.901 21.8891 9.8892L19.7678 7.76788ZM19.7678 8.34642C19.608 8.18667 19.608 7.92764 19.7678 7.76788L21.8891 9.8892C22.9009 8.87739 22.9009 7.23692 21.8891 6.2251L19.7678 8.34642ZM18.4821 7.06078L19.7678 8.34642L21.8891 6.2251L20.6034 4.93946L18.4821 7.06078ZM19.7678 3.65381L18.4821 4.93946L20.6034 7.06078L21.8891 5.77513L19.7678 3.65381Z",
    fill: "#FEFEFE",
    mask: "url(#path-3-outside-1_30_29806)"
  })))), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 280",
    cx: 8,
    cy: 9,
    r: 2,
    fill: "#FEFEFE"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemovePhotoIcon);
export default __webpack_public_path__ + "static/media/remove-photo-icon.881f69d9b67ee172b1ca1959d83e264b.svg";
export { ForwardRef as ReactComponent };